import { render, staticRenderFns } from "./BaseChip.vue?vue&type=template&id=49888fb4&scoped=true"
import script from "./BaseChip.vue?vue&type=script&lang=js"
export * from "./BaseChip.vue?vue&type=script&lang=js"
import style0 from "./BaseChip.vue?vue&type=style&index=0&id=49888fb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49888fb4",
  null
  
)

export default component.exports